import React from 'react';
import { Box, Card, CardContent, Typography, Stack, IconButton } from '@mui/material';
import { Instagram, WhatsApp, LinkedIn, YouTube } from '@mui/icons-material';

const FollowUs = () => {
    return (
        <Box sx={{ padding: 4 }}>
            <Stack direction="column" spacing={4} alignItems="center">
                {/* Card 1 */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column', // Align cards in a column
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 2, // Add some gap between the cards
                    }}
                >
                    {/* Card 1: REACH US */}
                    <Card sx={{
                        width: 300, textAlign: 'center', backgroundColor: 'transparent', // Make background transparent
                        boxShadow: 'none',
                    }}>
                        <img src='/images/reach-us.webp' width={200} />
                        <CardContent sx={{ padding: 0, margin: 0 }}>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 0,
                                margin: 0
                            }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '50px',
                                        paddingTop: 2,
                                        margin: 0,
                                        whiteSpace: 'nowrap',
                                        lineHeight: 0.1,
                                    }}
                                >
                                    REACH
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 'bold',
                                        fontSize: '140px',
                                        padding: 8,
                                        margin: 0,
                                        whiteSpace: 'nowrap',
                                        lineHeight: 0.1,
                                    }}
                                >
                                    US
                                </Typography>
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    lineHeight: 0.1,
                                    margin: 0,
                                    padding: 0,
                                }}
                            >
                                Get the latest updates and news.
                            </Typography>
                        </CardContent>
                    </Card>

                    {/* Card 2: Social Icons */}
                    <Card sx={{ width: 300, textAlign: 'center', backgroundColor: 'transparent' }}>
                        <CardContent sx={{ padding: 0 }}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 2,
                            }}>
                                {/* Instagram Icon */}
                                <IconButton
                                    onClick={() => window.open('https://www.instagram.com/markautodetailingid', '_blank')}
                                    color="primary"
                                >
                                    <Instagram />
                                </IconButton>

                                {/* WhatsApp Icon */}
                                <IconButton
                                    onClick={() => window.open('https://wa.me/yourphonenumber', '_blank')}
                                    color="primary"
                                >
                                    <WhatsApp />
                                </IconButton>

                                {/* LinkedIn Icon */}
                                <IconButton
                                    onClick={() => window.open('https://www.linkedin.com/company/markindogroup', '_blank')}
                                    color="primary"
                                >
                                    <LinkedIn />
                                </IconButton>

                                {/* YouTube Icon */}
                                <IconButton
                                    onClick={() => window.open('https://www.youtube.com/@markindonesia3408', '_blank')}
                                    color="primary"
                                >
                                    <YouTube />
                                </IconButton>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Stack>
        </Box>
    );
};

export default FollowUs;
